import { PhoneDTO } from "./dto/PhoneDTO";

export const InitialPhone: PhoneDTO = {
    userId: null,
    phone: "",
    viber: false,
    whatsapp: false,
};
